export default __webpack_public_path__ + "static/media/arrow-down.3231321d.svg";